import React from "react"
import PropTypes from "prop-types"
import Player from "react-player"
import SanityImage from "gatsby-plugin-sanity-image"
import useBreakpoints from "hooks/useBreakpoints"
import theme from "styles/theme"
import { heroHeights } from "./Hero"

const VideoHero = ({ background, title, video, size = "xl" }) => {
  const { tablet, mobile } = useBreakpoints()
  const [dH, tH, mH] = heroHeights[size]
  const minHeight = mobile ? mH : tablet ? tH : dH
  const minWidth = mobile ? 375 : tablet ? 767 : 1178

  return (
    <div
      css={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 24px",
        textAlign: "center",
        backgroundColor: "rgba(86, 90, 92, 0.12)",
        position: "relative",
        height: dH,
        minHeight: "calc(100vh - 350px)",
        maxHeight: "120vh",
        [theme.tablet]: { height: tH },
        [theme.mobile]: { height: mH },
      }}
    >
      <SanityImage
        {...background}
        width={minWidth}
        height={minHeight}
        css={{
          position: "absolute",
          width: "100%",
          height: "100%",
          zIndex: -1,
          objectFit: "cover",
          top: 0,
          left: 0,
        }}
        alt=""
      />

      <Player
        url={video.asset.url}
        muted
        playing
        playsinline
        loop
        controls={false}
        width="100%"
        height="100%"
        css={{
          position: "absolute",
          top: 0,
          left: 0,
        }}
        // The `style` prop does not get passed down to the `video` element
        // as it should, so we're exploiting an implementation detail where
        // `config.file.attributes` is expanded on the video element, allowing
        // us to override the default `style`.
        config={{
          file: {
            attributes: {
              style: {
                width: "100%",
                height: "100%",
                objectFit: "cover",
              },
            },
          },
        }}
      />

      <h1
        css={{
          ...theme.t1,
          margin: "0 auto",
          maxWidth: 942,
          color: theme.white,
          position: "relative",
        }}
      >
        {title}
      </h1>
    </div>
  )
}

export default VideoHero

VideoHero.propTypes = {
  background: PropTypes.shape({
    asset: PropTypes.object.isRequired,
  }),
  title: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["xl", "lg", "md"]),
  video: PropTypes.shape({
    asset: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}
